import { createBrowserHistory, History } from 'history';

export const rootHistory: History = createBrowserHistory();